import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import FilterBreadcrumbs from 'components/common/Filters/FilterBreadcrumbs'
import { FilterGroup } from 'components/common/Filters/FilterGroup'
import { PRICE_PER_TIRE_NAME, FILTER_DATA_ATTRIBUTES_BY_NAME } from '../constants'
import CustomPriceRangeForm from './CustomPriceRangeForm'

const Filters = ({
  className,
  title,
  navigation = [],
  filterItems,
  resetFilters,
  selectedFilters = [],
  totalNumRecs
}) =>
  <aside data-at-serp-filter className={ className }>
    <FilterBreadcrumbs
      title={ title }
      selectedFilters={ selectedFilters }
      onFilterClear={ resetFilters }
      onFilterRemove={ filterItems } />
    <FilterList>
      {
        navigation.map(({ name, refinements = [], ExpandedByDefault }) =>
          <li key={ name }>
            <FilterGroup
              dataAttribute={ FILTER_DATA_ATTRIBUTES_BY_NAME[name] }
              title={ name }
              refinements={ refinements }
              toggleOnName="View All"
              toggleOffName="Show Fewer"
              groupExpandedByDefault={ ExpandedByDefault }
              onChange={ filterItems }>
              {
                name === PRICE_PER_TIRE_NAME &&
                <CustomPriceRangeForm count={ totalNumRecs } refinements={ refinements } />
              }
            </FilterGroup>
          </li>
        )
      }
    </FilterList>
  </aside>

export default Filters

Filters.propTypes = {
  className: PropTypes.string,
  filterItems: PropTypes.func,
  navigation: PropTypes.arrayOf(PropTypes.shape()),
  resetFilters: PropTypes.func,
  selectedFilters: PropTypes.arrayOf(PropTypes.shape()),
  title: PropTypes.string,
  totalNumRecs: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

const FilterList = styled.ul`
  margin: 0;
  padding: 0;
  list-style-type: none;
`
